import { LoquixGenerationControls } from './loquix-generation-controls.js';

if (!customElements.get('loquix-generation-controls')) {
  customElements.define('loquix-generation-controls', LoquixGenerationControls);
}
